const STORAGE_KEY = "seen_bco_thought_traces";

function getSeenBcoIds() {
    try {
        const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return Array.isArray(stored) ? stored.filter((id) => typeof id === "string") : [];
    } catch {
        return [];
    }
}

export function hasSeenBcoThoughtTrace(bcoId) {
    return getSeenBcoIds().includes(String(bcoId));
}

export function rememberBcoThoughtTrace(bcoId) {
    const id = String(bcoId);
    const ids = getSeenBcoIds();
    if (!ids.includes(id)) {
        ids.push(id);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    }
}

// The reveal belongs to the session that watched it, so signing out or signing back in
// hands the next user every trace from the start.
export function forgetBcoThoughtTraces() {
    localStorage.removeItem(STORAGE_KEY);
}
